import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pr0024',
    ecrans: ['00-2']
});
